import React from "react";
import { Button } from "reactstrap";
import blueArrow from "assets/images/chpt/blue-arrow.png";
import { motion } from "framer-motion/dist/framer-motion";
import {
  bounce_right_to_left_variants_delay_flip_out_x
} from "shared/components/animations";
const FlipModal = ({ ButtonClick = () => {} }) => {
  return (
    <motion.div   initial="hidden"
    animate="visible"
    exit="exit"  variants={bounce_right_to_left_variants_delay_flip_out_x}   className="flip-modal">
      <div >
        <div className="flip-modal-title">
          <h4>
            CHARTY <img src={blueArrow} alt="blueArrow" /> PARTY
          </h4>
          <h6>
            THE GAME <span>OF</span> ABSURDLY FUNNY CHARTS
          </h6>
        </div>
        <Button className="primary-solid  " onClick={() => ButtonClick()}>
          FLIP
        </Button>
      </div>
    </motion.div>
  );
};

export default FlipModal;
